<feature-auth-login
  [onLoginSuccess]="handleLoginSuccess"
  [onLoginError]="handleLoginError"
  [onResetError]="handleResetError"
></feature-auth-login>
